































import { Component, Vue, Prop, Inject } from 'vue-property-decorator'

@Component
export default class PromotionSeckill extends Vue {
  @Prop({ default: () => {} }) readonly panicbuy!: any

  @Inject({ from: 'toPanicBuyEP', default: null }) toPanicBuyEP!: any
  moreExposure(item: any) {
    const { spuId = '' } = item
    return this.toPanicBuyEP && this.toPanicBuyEP({ spuId: spuId })
  }
  moreClicked(item: any) {
    const { spuId = '' } = item
    this.$emit('toPanicBuy', spuId)
    this.$router.push({ name: 'panicbuy', query: { spuId } })
  }

  get panicbuyArray() {
    if (!this.panicbuy.promotionList) {
      return []
    } else {
      if (this.panicbuy.promotionList.length < 5) {
        return this.panicbuy.promotionList
      }
      return this.panicbuy.promotionList.slice(0, 5)
    }
  }
}
